import {authorizationServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = authorizationServicesPath + '/organizations/selco-file-fields-order'

export default class SelcoFileFieldsService {

    static async get() {
        return axios.get(restUrl);
    }

    static async save(data) {
        return await axios.post(restUrl, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async edit(data) {
        return await axios.put(restUrl+ '/' + data.id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        return  await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async editDefault(id) {
        return await axios.patch(restUrl + '/' + id + "/default", [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}